const env = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    cryptoSecret: process.env.REACT_APP_CRYPTO_SECRET_KEY,
    appUrl: process.env.REACT_APP_URL,
    notificationKey: process.env.REACT_APP_NOTIFICATION_KEY,
    razorpay: {
        id: process.env.REACT_APP_RAZORPAY_KEY_ID,
        secret: process.env.REACT_APP_RAZORPAY_KEY_SECRET
    },
    whatsapp: {
        businessNumber: process.env.REACT_APP_BUSINESS_NUMBER,
        demoNumber: process.env.REACT_APP_WHATSAPP_DEMO_NUMBER
    },
    tenant: JSON.parse(process.env.REACT_APP_TENANT_MAPPING || '{}')
};

export default env;
